<template>
  <div style="min-width: 120px;" class="d-flex flex-column">
    <div 
      class="mx-auto" 
      style="line-height: 14px;"
    >
      {{ ticker }} 
    </div>
    <div
      class="d-flex justify-center"
      :class="{ 
      }"
    >
      <h1 class="highlight-value">
        {{ changeValue }}
      </h1>
    </div>
  </div>
</template>

<script>
import { useColorsStore } from "@/store";
import { mapState } from "pinia";

export default {
  props: {
    interval: {
      required: false,
      default: 0.0001
    },
    options: {
      required: false,
      type: Object
    },
    ticker: {
      required: true,
      type: String
    },
    tickersData: {
      required: true,
      type: Object
    }
  },
  computed: {
    ...mapState(useColorsStore, [
      "orangeColor",
      "aliveColor"
    ]),
    changeValue() {
      if (!this.tickersData || Object.keys(this.tickersData).length === 0) {
        return
      }

      const keys = Object.keys(this.tickersData)
      const firstKey = keys[0]
      const firstKeyData = Number(this.tickersData[firstKey]['4. close'])

      if(this.ticker === "JPY/USD") return firstKeyData.toFixed(6)
      if(!firstKeyData) return '-'

      return firstKeyData.toFixed(4)
    },
  }
}
</script>

<style scoped>
  .highlight-value {
    font-weight: 400 !important;
  }
  .highlight-value:hover {
    font-weight: 700 !important;
  }
</style>